import { Namespace } from "@cirrus/fe-lib"

import { core } from "../_params.js"

export const shared = {
  domain: Namespace.domain(core, "shared"),
}
